var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWixLogo = function SvgWixLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 14,
    viewBox: "0 0 34 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wix-logo_svg__a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.577.5h-1.855c-.514 0-.995.255-1.284.68l-2.48 3.66a.167.167 0 0 1-.276 0l-2.48-3.66A1.55 1.55 0 0 0 23.917.5h-1.855l4.42 6.518-4.395 6.482h1.855c.514 0 .995-.255 1.284-.68l2.456-3.624a.167.167 0 0 1 .276 0l2.456 3.623c.288.426.77.681 1.284.681h1.855l-4.395-6.482L33.578.5ZM18.246 1.83V13.5h.887a1.33 1.33 0 0 0 1.33-1.33V.5h-.887a1.33 1.33 0 0 0-1.33 1.33ZM16.621.5h-.789c-.868 0-1.62.6-1.813 1.447l-1.765 7.758-1.545-7.242A2.464 2.464 0 0 0 7.645.611C6.75.858 6.086 1.614 5.893 2.522l-1.53 7.174-1.76-7.748A1.861 1.861 0 0 0 .787.5H0l2.956 13h1.12c1.017 0 1.895-.711 2.107-1.705l1.89-8.87a.24.24 0 0 1 .235-.19c.112 0 .21.08.234.19l1.892 8.87A2.154 2.154 0 0 0 12.54 13.5h1.124L16.621.5Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wix-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h33.578v13H0z"
  })))));
};
export default SvgWixLogo;